import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'termId',
                              },
                              '!name': {
                                '@$': 'termName',
                              },
                              '!code': {
                                '@$': 'termName',
                              },
                              '!descr': {
                                '@$': 'termDescr',
                              },
                              '!risk_threshold': {
                                '@$': 'termRiskThreshold',
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'ent:!subaward_tcs:!tc',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
